import {DispatchContext, Job} from "@/core/types";
import {getEmployees} from "@/core/api/employee";

export default class LoadEmployeesJob implements Job {
  private readonly userId: number;
  private readonly page: number;

  constructor(userId: number, page: number) {
    this.userId = userId;
    this.page = page;
  }

  async run(context: DispatchContext): Promise<any> {
    const response = await getEmployees(this.userId, this.page);

    context.store.commit('user/setEmployees', response.data.data);

    const employee = context.store.state.user.employee.selectedEmployee;

    if (employee !== null) {
      const users = context.store.state.user.employee.employees.filter((e: any) => e.id === employee.id);

      context.store.commit('user/setSelectedEmployee', users[0]);
    }
  }
}
